import type { ExtractDeleteRoutes, RouteSegment } from '@openclassrooms/sdk';
import useMutationRequest from './useMutationRequest';
import type { ApiRoutes, DeleteRequestBuilder, RequestOption, MutateOptions } from '../types';
export default function useDelete(path, mutationOptions) {
  return useMutationRequest("DELETE", path, mutationOptions);
}